// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"ProjectFilterBox_checkboxContainer_3RVLu","checkboxSubContainer":"ProjectFilterBox_checkboxSubContainer_zhQGR","spinAround":"ProjectFilterBox_spinAround_1oSD3"};